import { Box, Divider, Paper, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import AdminBarChart from "./BarChart";

function OrderReportChart({ chartData, isLoading }) {
  const { t } = useTranslation(["report", "common"]);
  return (
    <Paper sx={{ borderRadius: 1, mt: 3 }}>
      <Typography fontSize={"1.25rem"} fontWeight={600} p={2}>
        {t("orderMonthlyReportChart")}
      </Typography>

      <Divider />
      {chartData?.length > 0 ? (
        <Box p={2}>
          <AdminBarChart chartData={chartData} />
        </Box>
      ) : (
        chartData?.length === 0 &&
        isLoading === false && (
          <Typography
            variant="h6"
            fontWeight={600}
            my={2}
            textAlign={"center"}
            p={2}
          >
            {t("noDataFound", { ns: "common" })}
          </Typography>
        )
      )}
    </Paper>
  );
}

export default OrderReportChart;
